import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML with DOMPurify (strips scripts, event handlers, etc.) then marks as safe for innerHTML.
 * Use for user-generated content from rich-text editors.
 */
@Pipe({ name: 'safeHtml', standalone: true })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html: string | null | undefined): SafeHtml {
    if (html == null || html === '') {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }
    const clean = DOMPurify.sanitize(html, {
      ALLOWED_TAGS: [
        'b', 'i', 'u', 'em', 'strong', 'a', 'p', 'br', 'hr', 'ul', 'ol', 'li',
        'blockquote', 'code', 'pre', 'sub', 'sup',
        'table', 'thead', 'tbody', 'tr', 'th', 'td', 'caption',
        'span', 'div', 'h1', 'h2', 'h3', 'img',
      ],
      ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'title'],
    });
    return this.sanitizer.bypassSecurityTrustHtml(clean);
  }
}
